import { request } from 'umi';

export interface MaintenanceStatus {
  enabled: boolean;
}

export async function getMaintenanceStatusApi(): Promise<MaintenanceStatus> {
  return request('/maintenance/status', {
    method: 'get',
    skipErrorMessage: true,
  });
}
